import { render, staticRenderFns } from "./PaginaImportaBilancioCoccia.vue?vue&type=template&id=f28c5a00"
import script from "./PaginaImportaBilancioCoccia.vue?vue&type=script&lang=js"
export * from "./PaginaImportaBilancioCoccia.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaBilancioCoccia.vue?vue&type=style&index=0&id=f28c5a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports